//test

const Envirnment = {

  contractAddress: "0x888f1E8E1E096bcC491c007DA0ED1Ddd69b643d0",

}
export default Envirnment


